import React from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from './Icon';
export const IconTwoCoins = (props) => {
    const id = React.useId();
    const gradientId = `gradient_${id}`;
    return (<IconWithGradient id={id} defaultGradientKey="deepPink" {...props}>
      <Path d="M22.0001 8.5C22.0001 11.76 19.6001 14.45 16.4801 14.92V14.86C16.1701 10.98 13.0201 7.83 9.11008 7.52H9.08008C9.55008 4.4 12.2401 2 15.5001 2C19.0901 2 22.0001 4.91 22.0001 8.5Z" fill={`url(#${gradientId})`}/>
      <Path d="M14.98 14.98C14.73 11.81 12.19 9.27 9.02 9.02C8.85 9.01 8.67 9 8.5 9C4.91 9 2 11.91 2 15.5C2 19.09 4.91 22 8.5 22C12.09 22 15 19.09 15 15.5C15 15.33 14.99 15.15 14.98 14.98ZM9.38 16.38L8.5 18L7.62 16.38L6 15.5L7.62 14.62L8.5 13L9.38 14.62L11 15.5L9.38 16.38Z" fill={`url(#${gradientId})`}/>
    </IconWithGradient>);
};
